import IconWrapper from "@components/atoms/icon-wrapper";

import { HeaderContainer, HeaderTitle, Wrapper } from "./header.styled";
import { HeaderProps } from "./header.type";

import { ReactComponent as Back } from "@assets/images/chevrons/chevron-left.svg";

const Header = ({ icon, title, handleBack, handleClick }: HeaderProps) => {
  return (
    <HeaderContainer>
      <Wrapper>
        {handleBack && (
          <IconWrapper handleClick={handleBack}>{<Back />}</IconWrapper>
        )}
        <HeaderTitle>{title}</HeaderTitle>
      </Wrapper>
      <IconWrapper handleClick={handleClick}>{icon}</IconWrapper>
    </HeaderContainer>
  );
};

export default Header;
